import { ChangeDetectorRef, Component, OnChanges, SimpleChanges, input, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NotificationService } from '@app/core/services/notification.service';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { finalize, map, take } from 'rxjs/operators';
import { InformationDisclosure } from '../../models/trade-in-api.model';
import { EquipmentService } from '@app/sales/services/equipment.service';
import { ThemeService } from '@app/core/services/theme.service';
import { Observable } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { themes } from '@app/core/constants/themes';

@Component({
  selector: 'app-information-disclosure',
  imports: [SpinnerComponent, MatIcon, AsyncPipe, NgClass],
  templateUrl: './information-disclosure.component.html',
  styleUrl: './information-disclosure.component.scss',
})
export class InformationDisclosureComponent implements OnChanges {
  private equipmentService = inject(EquipmentService);
  private notificationService = inject(NotificationService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private themeService = inject(ThemeService);

  inquiredInfoDisclosure = input<string>();
  disclosure: InformationDisclosure;
  isFetchingDisclosure = false;
  expandedState: 'default' | 'rotated' = 'rotated';
  IconNames = IconNames;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inquiredInfoDisclosure) {
      this.fetchInformationDisclosure();
    }
  }

  private fetchInformationDisclosure(): void {
    const key = this.inquiredInfoDisclosure();
    if (!key || this.disclosure?.informationKey === key) return;

    this.isFetchingDisclosure = true;

    this.equipmentService
      .getInformationDisclosure(key)
      .pipe(
        take(1),
        finalize(() => {
          this.isFetchingDisclosure = false;
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: disclosure => (this.disclosure = disclosure),
        error: error => this.notificationService.error('Error fetching information disclosure', error),
      });
  }

  toggleExpandedState(): void {
    this.expandedState = this.expandedState === 'default' ? 'rotated' : 'default';
  }

  get isDarkMode(): Observable<boolean> {
    const darkTheme = themes[1];
    return this.themeService.selectedTheme.pipe(
      take(1),
      map(theme => theme.name === darkTheme.name)
    );
  }
}
